// src/pages/CustomerSpecialPrice/CustomerSpecialPriceThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  saveSpecialPriceApi,
  getSpecialPriceApi,
  deleteSpecialPriceApi,
  getCustomerGroupApi,
  getCustomerGroupPriceApi,
} from "../../apiservice/sales";
import { getItemBySearchApi } from "../../apiservice/accounts";
import { getAccountBySeachApi } from "../../apiservice/setting";
import { setCustomersGroups, setItems } from "./CustomerSpecialPriceSlice";

// Fetch list
export const fetchCustomerSpecialPriceList = createAsyncThunk(
  "customerSpecialPrice/fetchList",
  async () => {
    const res = await getSpecialPriceApi();
    return res.data.map((item) => ({
      ...item,
      display_name:
        item.acc_name == null
          ? `${item.group_name} (Group)`
          : `${item.acc_name} (Customer)`,
    }));
  }
);

// Save
export const saveCustomerSpecialPrice = createAsyncThunk(
  "customerSpecialPrice/save",
  async (payload, { dispatch }) => {
    const res = await saveSpecialPriceApi(payload);
    dispatch(fetchCustomerSpecialPriceList());
    return res.data;
  }
);

// Delete
export const deleteCustomerSpecialPrice = createAsyncThunk(
  "customerSpecialPrice/delete",
  async (id, { dispatch }) => {
    await deleteSpecialPriceApi({ id });
    dispatch(fetchCustomerSpecialPriceList());
    return id;
  }
);

// Edit
export const editCustomerSpecialPrice = (record) => (dispatch) => {
  dispatch({
    type: "customerSpecialPrice/setFormData",
    payload: record,
  });
};

// Fetch items
export const fetchItems = () => async (dispatch) => {
  const res = await getItemBySearchApi({ query: null, search: true, partyType: "sale_rate" });
  dispatch(setItems(res.data));
};

// Fetch customers + groups
export const fetchCustomersAndGroups = () => async (dispatch) => {
  const customersRes = await getAccountBySeachApi({
    query: null,
    type: "debitor",
    acc_type_name: ["Customer"],
  });
  const customerWithType = customersRes.data.map((item) => ({
    ...item,
    acc_name: `${item.acc_name} (Customer)`,
    type: "customer",
  }));

  const groupsRes = await getCustomerGroupApi(null);
  const groupWithType = groupsRes.data.map((item) => ({
    ...item,
    acc_id: item.id,
    acc_name: `${item.name} (Group)`,
    type: "group",
  }));

  dispatch(setCustomersGroups([...customerWithType, ...groupWithType]));
};
